var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"cta-content"}},[_c('div',{staticClass:"container content_title"}),_c('CTABanner',{attrs:{"onlyBanner":true,"bannerData":{bannerText: 'See PK PROFILE', href:'/pk-data'}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }